import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { traineeKeys, useTraineeId } from "~/modules/Trainee/TraineeProfile/scope";

/**
 * Buildery w TraineeStoreGate piszą przez Redux, a nagłówek karty (plan, dieta, dostęp) czyta
 * react-query. Realtime odświeża go tylko po zmianie wiersza `trainee`, więc zapis, który zmienia
 * inne tabele widoczne poza bramką (np. `client_training_program`), odświeża kartę sam.
 */
export const useInvalidateTraineeCard = () => {
  const traineeId = useTraineeId();
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: traineeKeys.all(traineeId) }),
    [queryClient, traineeId],
  );
};
